import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import API from "./config/API";

function UserBedBooking() {
  const navigate = useNavigate();
  const location = useLocation();

  // ================= LOCATION DATA =================
  const userData = location.state || {};

  // ================= USER REGISTER ID =================
  const userRegisterId =
    userData.userRegisterId || userData.userRegistrationId || "";

  // ================= USER NAME =================
  const firstName = userData.firstName || "";
  const lastName = userData.lastName || "";

  // ================= CREATED BY =================
  const userCreatedBy = JSON.parse(localStorage.getItem("user"))?.emailId || "";

  // ================= STATES =================
  const [floors, setFloors] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [beds, setBeds] = useState([]);

  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const [form, setForm] = useState({
    userFloorId: "",
    userFloorName: "",

    userRoomId: "",
    userRoomName: "",

    userBedId: "",
    userBedName: "",

    bedCost: "",

    snoringHabbit: "No",

    bedBookingType: "",
  });

  // =====================================================
  // DYNAMIC API URL
  // =====================================================
  const floorRoomsApi = `${API.V2}/floor_rooms/getUserDashboardDetails`;

  const bedBookingApi = `${API.V2}/user/bedBooking`;

  // ================= LOAD FLOORS =================
  useEffect(() => {
    fetchFloors();
  }, []);

  // ================= FETCH FLOORS =================
  const fetchFloors = async () => {
    try {
      console.log("Get Floor API:", floorRoomsApi);

      const res = await fetch(floorRoomsApi, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          emailId: userCreatedBy,
          floorName: null,
          roomName: null,
        }),
      });

      const data = await res.json();

      console.log("Floor API Response:", data);

      if (data.statusCode === 200) {
        setFloors(data?.data?.floorwiseBedsCount || []);
      } else {
        console.error(data?.message || "Unable to load floors");
      }
    } catch (error) {
      console.error("Fetch Floors Error:", error);
    }
  };

  // ================= FLOOR CHANGE =================
  const handleFloorChange = async (e) => {
    const floorName = e.target.value;

    const selectedFloor = floors.find((f) => f.floorName === floorName);

    setForm((prev) => ({
      ...prev,

      userFloorId: selectedFloor?.floorId || "",
      userFloorName: selectedFloor?.floorName || "",

      userRoomId: "",
      userRoomName: "",

      userBedId: "",
      userBedName: "",

      bedCost: "",
    }));

    setRooms([]);
    setBeds([]);

    try {
      console.log("Get Rooms API:", floorRoomsApi);

      const res = await fetch(floorRoomsApi, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          emailId: userCreatedBy,
          floorName: floorName,
          roomName: null,
        }),
      });

      const data = await res.json();

      console.log("Room API Response:", data);

      if (data.statusCode === 200) {
        setRooms(data?.data?.roomwiseBedsCounts || []);
      } else {
        console.error(data?.message || "Unable to load rooms");
      }
    } catch (error) {
      console.error("Fetch Rooms Error:", error);
    }
  };

  // ================= ROOM CHANGE =================
  const handleRoomChange = async (e) => {
    const roomName = e.target.value;

    const selectedRoom = rooms.find((r) => r.roomName === roomName);

    const selectedFloorName = form.userFloorName;

    setForm((prev) => ({
      ...prev,

      userRoomId: selectedRoom?.roomId || "",
      userRoomName: selectedRoom?.roomName || "",

      userBedId: "",
      userBedName: "",

      bedCost: "",
    }));

    setBeds([]);

    try {
      console.log("Get Beds API:", floorRoomsApi);

      const res = await fetch(floorRoomsApi, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          emailId: userCreatedBy,
          floorName: selectedFloorName,
          roomName: roomName,
        }),
      });

      const data = await res.json();

      console.log("Bed API Response:", data);

      if (data.statusCode === 200) {
        setBeds(data?.data?.availbaleBeds || []);
      } else {
        console.error(data?.message || "Unable to load beds");
      }
    } catch (error) {
      console.error("Fetch Beds Error:", error);
    }
  };

  // ================= BED CHANGE =================
  const handleBedChange = (e) => {
    const bedName = e.target.value;

    const selectedBed = beds.find((b) => b.bedName === bedName);

    setForm((prev) => ({
      ...prev,

      userBedId: selectedBed?.bedId || "",
      userBedName: selectedBed?.bedName || "",

      // STATIC COST
      bedCost: 5000,
    }));
  };

  // ================= SNORING =================
  const handleSnoringChange = (e) => {
    setForm((prev) => ({
      ...prev,
      snoringHabbit: e.target.value,
    }));
  };

  // ================= BOOKING TYPE =================
  const handleBookingTypeChange = (e) => {
    setForm((prev) => ({
      ...prev,
      bedBookingType: e.target.value,
    }));
  };

  // ================= BOOK BED =================
  const handleBookBed = async () => {
    if (!form.userFloorId) {
      alert("Select Floor");
      return;
    }

    if (!form.userRoomId) {
      alert("Select Room");
      return;
    }

    if (!form.userBedId) {
      alert("Select Bed");
      return;
    }

    if (!form.bedBookingType) {
      alert("Select Booking Type");
      return;
    }

    setLoading(true);

    // ================= PAYLOAD =================
    const payload = {
      userRegisterId: userRegisterId,

      userFloorId: form.userFloorId,
      userFloorName: form.userFloorName,

      userRoomId: form.userRoomId,
      userRoomName: form.userRoomName,

      userBedId: form.userBedId,
      userBedName: form.userBedName,

      bedStatus: "BOOKED",

      userCreatedBy: userCreatedBy,

      snoringHabbit: form.snoringHabbit,

      bedBookingType: form.bedBookingType,
    };

    try {
      console.log("Bed Booking API:", bedBookingApi);

      console.log("Bed Booking Payload:", payload);

      const res = await fetch(bedBookingApi, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      console.log("Bed Booking Response:", data);

      if (data.statusCode === 200) {
        setShowPopup(true);

        setTimeout(() => {
          navigate("/userPaymentForm", {
            state: {
              // BOOKING ID
              userBookingId: data?.data?.userBookingId,

              // FIRST NAME
              firstName: firstName,

              // LAST NAME
              lastName: lastName,

              // USER REGISTER ID
              userRegisterId: userRegisterId,

              // TOTAL BED COST
              totalBedCost: form.bedCost,
            },
          });
        }, 1500);
      } else {
        alert(data?.message || "Bed booking failed");
      }
    } catch (error) {
      console.error("Bed Booking Error:", error);

      alert("Unable to book bed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // ================= UI =================
  return (
    <div style={styles.container}>
      {/* ================= SUCCESS POPUP ================= */}
      {showPopup && (
        <div style={styles.popupOverlay}>
          <div style={styles.popupBox}>
            <div style={styles.successIcon}>✅</div>

            <h2 style={styles.popupTitle}>Bed Booked Successfully</h2>

            <p style={styles.popupText}>Redirecting...</p>
          </div>
        </div>
      )}

      {/* ================= MAIN CARD ================= */}
      <div style={styles.card}>
        <h1 style={styles.title}>🏠 User Bed Booking</h1>

        <div style={styles.grid}>
          {/* BOOKING TYPE */}
          <select
            value={form.bedBookingType}
            onChange={handleBookingTypeChange}
            style={styles.floorInput}
          >
            <option value="">Select Booking Type</option>

            <option value="AdvanceBooking">Advance Booking</option>

            <option value="BookingNow">Booking Now</option>
          </select>

          {/* SNORING */}
          <div style={styles.floorInput}>
            <label>Snoring Habit</label>

            <div style={{ marginTop: "10px" }}>
              <input
                type="radio"
                value="Yes"
                checked={form.snoringHabbit === "Yes"}
                onChange={handleSnoringChange}
              />{" "}
              Yes
              <input
                type="radio"
                value="No"
                checked={form.snoringHabbit === "No"}
                onChange={handleSnoringChange}
                style={{ marginLeft: 20 }}
              />{" "}
              No
            </div>
          </div>

          {/* FLOOR */}
          <select
            value={form.userFloorName}
            onChange={handleFloorChange}
            style={styles.floorInput}
          >
            <option value="">Select Floor</option>

            {floors.map((floor) => (
              <option key={floor.floorId} value={floor.floorName}>
                {floor.floorName} ({floor.floorWisetotalBedsCount})
              </option>
            ))}
          </select>

          {/* ROOM */}
          <select
            value={form.userRoomName}
            onChange={handleRoomChange}
            style={styles.roomInput}
          >
            <option value="">Select Room</option>

            {rooms.map((room) => (
              <option key={room.roomId} value={room.roomName}>
                {room.roomName} ({room.roomWiseBedsCount})
              </option>
            ))}
          </select>

          {/* BED */}
          <select
            value={form.userBedName}
            onChange={handleBedChange}
            style={styles.bedInput}
          >
            <option value="">Select Bed</option>

            {beds.map((bed) => (
              <option key={bed.bedId} value={bed.bedName}>
                {bed.bedName}
              </option>
            ))}
          </select>

          {/* COST */}
          <input
            type="text"
            value={form.bedCost ? `₹ ${form.bedCost}` : ""}
            disabled
            style={styles.costInput}
            placeholder="Bed Cost"
          />
        </div>

        {/* ================= SUMMARY ================= */}
        <div style={styles.summaryContainer}>
          <div style={styles.summaryCard}>
            <h3>🏢 Floor</h3>
            <p>{form.userFloorName || "Not Selected"}</p>
          </div>

          <div style={styles.summaryCard}>
            <h3>🚪 Room</h3>
            <p>{form.userRoomName || "Not Selected"}</p>
          </div>

          <div style={styles.summaryCard}>
            <h3>🛏 Bed</h3>
            <p>{form.userBedName || "Not Selected"}</p>
          </div>

          <div style={styles.summaryCard}>
            <h3>💰 Cost</h3>
            <p>₹ {form.bedCost || 0}</p>
          </div>
        </div>

        {/* ================= BOOK BUTTON ================= */}
        <button
          style={styles.bookBtn}
          onClick={handleBookBed}
          disabled={loading}
        >
          {loading ? "Booking..." : "🛏 Book Bed"}
        </button>
      </div>
    </div>
  );
}

export default UserBedBooking;

// =====================================================
// STYLES
// =====================================================

const styles = {
  container: {
    minHeight: "100vh",
    background: "linear-gradient(135deg,#dbeafe,#f8fafc,#e0f2fe)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "30px",
    fontFamily: "Segoe UI",
  },

  card: {
    width: "100%",
    maxWidth: "1150px",
    background: "#ffffff",
    borderRadius: "24px",
    padding: "40px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.12)",
  },

  title: {
    textAlign: "center",
    fontSize: "38px",
    fontWeight: "bold",
    marginBottom: "35px",
    color: "#0f172a",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
    gap: "20px",
  },

  floorInput: {
    padding: "16px",
    borderRadius: "14px",
    border: "2px solid #93c5fd",
    background: "#dbeafe",
    fontSize: "15px",
    fontWeight: "600",
    outline: "none",
  },

  roomInput: {
    padding: "16px",
    borderRadius: "14px",
    border: "2px solid #86efac",
    background: "#dcfce7",
    fontSize: "15px",
    fontWeight: "600",
    outline: "none",
  },

  bedInput: {
    padding: "16px",
    borderRadius: "14px",
    border: "2px solid #d8b4fe",
    background: "#f3e8ff",
    fontSize: "15px",
    fontWeight: "600",
    outline: "none",
  },

  costInput: {
    padding: "16px",
    borderRadius: "14px",
    border: "2px solid #fdba74",
    background: "#ffedd5",
    fontSize: "16px",
    fontWeight: "bold",
    color: "#ea580c",
    outline: "none",
  },

  summaryContainer: {
    marginTop: "35px",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
    gap: "20px",
  },

  summaryCard: {
    background: "linear-gradient(135deg,#2563eb,#06b6d4)",
    color: "#fff",
    borderRadius: "18px",
    padding: "25px",
    textAlign: "center",
    fontWeight: "bold",
  },

  bookBtn: {
    width: "100%",
    marginTop: "25px",
    padding: "18px",
    border: "none",
    borderRadius: "16px",
    background: "linear-gradient(45deg,#4f46e5,#06b6d4)",
    color: "#fff",
    fontSize: "18px",
    fontWeight: "bold",
    cursor: "pointer",
  },

  popupOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.45)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 99999,
  },

  popupBox: {
    width: "380px",
    background: "#fff",
    borderRadius: "24px",
    padding: "40px 30px",
    textAlign: "center",
  },

  successIcon: {
    fontSize: "70px",
    marginBottom: "20px",
  },

  popupTitle: {
    margin: 0,
    fontSize: "28px",
    fontWeight: "bold",
    color: "#16a34a",
  },

  popupText: {
    marginTop: "12px",
    fontSize: "16px",
    color: "#475569",
    fontWeight: "500",
  },
};
